export const Users = [
  {
    id:1,
    profilePicture: "assets/person/1.jpeg",
    username: "Safak Kocaoglu",
  },
  {
    id:2,
    profilePicture: "assets/person/2.jpeg",
    username: "Janell Shrum",
  },
  {
    id:3,
    profilePicture: "assets/person/3.jpeg",
    username: "Alex Durden",
  },
  {
    id:4,
    profilePicture: "assets/person/4.jpeg",
    username: "Dora Hawks",
  },
  {
    id:5,
    profilePicture: "assets/person/5.jpeg",
    username: "Thomas Holden",
  },
  {
    id:6,
    profilePicture: "assets/person/6.jpeg",
    username: "Shirley Beauchamp",
  },
  {
    id:7,
    profilePicture: "assets/person/7.jpeg",
    username: "Travis Bennett",
  },
  {
    id:8,
    profilePicture: "assets/person/8.jpeg",
    username: "Kristen Thomas",
  },
  {
    id:9,
    profilePicture: "assets/person/9.jpeg",
    username: "Gary Duty",
  },
  {
    id:10,
    profilePicture: "assets/person/10.jpeg",
    username: "Safak Kocaoglu",
  },
];

export const Posts = [
  {
    id: 1,
    desc: "Love For All, Hatred For None.",
    photo: "assets/post/1.jpeg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 1,
    comments: [
      {
        commentId: 1,
        userId: 2,
        body: "Superrr:)) aosnaiscndasi nvdindvoasi nviasn d v iuasn vdoisod saoinoi snvodisn cokaxocai v now i enocmxslk coiwnv dosinaksmo kvdnoai sndoindamd oascoians",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
  {
    id: 2,
    photo: "assets/post/2.jpeg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
    comments: [
      {
        commentId: 1,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
  {
    id: 3,
    desc: "Every moment is a fresh beginning.",
    photo: "assets/post/3.jpeg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
    comments: [
      {
        commentId: 1,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 2,
        userId: 5,
        body: "Heyy bro, wassup",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
  {
    id: 4,
    photo: "assets/post/4.jpeg",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 0,
    comments: [],
  },
  {
    id: 5,
    photo: "assets/post/5.jpeg",
    date: "5 hours ago",
    userId: 5,
    like: 23,
    comment: 0,
    comments: [],
  },
  {
    id: 6,
    photo: "assets/post/6.jpeg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 0,
    comments: [],
  },
  {
    id: 7,
    desc: "Never regret anything that made you smile.",
    photo: "assets/post/7.jpeg",
    date: "2 days ago",
    userId: 7,
    like: 52,
    comment: 1,
    comments: [
      {
        commentId: 1,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
  {
    id: 8,
    photo: "assets/post/8.jpeg",
    date: "3 days ago",
    userId: 8,
    like: 15,
    comment: 2,
    comments: [
      {
        commentId: 1,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 2,
        userId: 7,
        body: "Awesome Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
  {
    id: 9,
    desc: "Change the world by being yourself.",
    photo: "assets/post/9.jpeg",
    date: "5 days ago",
    userId: 9,
    like: 11,
    comment: 2,
    comments: [
      {
        commentId: 1,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 2,
        userId: 7,
        body: "Awesome Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
  {
    id: 10,
    photo: "assets/post/10.jpeg",
    date: "1 week ago",
    userId: 10,
    like: 104,
    comment: 6,
    comments: [
      {
        commentId: 1,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 2,
        userId: 7,
        body: "Awesome Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 3,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 4,
        userId: 7,
        body: "Awesome Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 5,
        userId: 1,
        body: "Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
      {
        commentId: 6,
        userId: 7,
        body: "Awesome Awesome;)",
        timeStamp: ["2022", "09", "20", "13", "01", "32", "09"], // timestamp [year, month, day, hours, mins, secs, milliseconds]
        recomments: [],
      },
    ],
  },
];
